import { setLStorage } from "global.d";
import { FC, useState, useEffect, useRef } from "react";
import { Button } from "../Button";
import { position } from "_metronic/assets/bootstrap/js/dist/dom/manipulator";

const ColumnGrid: FC<columnGridProps> = (props) => {
    const [isCheckbox, setIsCheckbox] = useState(false);

    return (
        <thead>
            <tr className="fw-bolder text-muted" style={{ position: "sticky", top: "0" }}>
                {props.isCheckbox ? (
                    <th className="w-25px" style={{ position: "sticky", left: "150px", zIndex: "2" }}>
                        <div className="form-check form-check-sm form-check-custom form-check-solid">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                value="1"
                                defaultChecked={isCheckbox}
                                data-kt-check="true"
                                data-kt-check-target=".widget-13-check"
                                onClick={() => {
                                    setIsCheckbox(!isCheckbox);
                                }}
                            />
                        </div>
                    </th>
                ) : null}
                {props.column?.map((item: columnGrid, key: number) => (
                    <ColumnHeader
                        key={item.key}
                        item={item}
                        index={key}
                        isMinutaVertical={props.isMinutaVertical}
                        isMinutaHorizontal={props.isMinutaHorizontal}
                    />
                ))}
            </tr>
        </thead>
    );
};

const ColumnHeader: FC<ColumnHeaderProps> = ({ item, index, isMinutaVertical, isMinutaHorizontal }) => {
    const thRef = useRef<HTMLTableHeaderCellElement>(null);
    const getTitleColumn = (text: string): string => {
        if (!text) return '';

        const newTitle: Record<string, string> = {
            '% ponderado': '%',
            '$ plato': '$',
            '$ Plato Pond.': '$%',
        };
        return newTitle[text] || text;
    };

    useEffect(() => {
        if (
            thRef.current &&
            (item.text?.includes("%") || item.text?.includes("$"))
        ) {
            thRef.current.style.setProperty("width", "45px", "important");
            thRef.current.style.setProperty("max-width", "45px", "important");
            thRef.current.style.setProperty("min-width", "45px", "important");
        }
    }, [item.text]);
    let classHead = "";
    if (item.dataFecha) {
        classHead += item.dataFecha.IsFeriado > 0 ? " holiday" : "";
        classHead += item.dataFecha.WK > 0 ? " weekend" : "";
    }
    let fijo = "";
    let firstColumn = "";
    let scope = "";
    const length = item.hideColumn ? item.hideColumn.length : 0;
    if (item.key === "nombreEstructura" || length > 0) {
        fijo = " colum-fecha";
    }
    if (item.key === "nombreEstructura") {
        fijo = " colum-fija2 clase-row-2";
        scope = "col";
    }
    if (index === 1) {
        //firstColumn = " first-col";


    }
    if (item.text?.includes("%") || item.text?.includes("$")) {
        item.classNameColum = item.classNameColum + " expand-column";
    }
    item.classNameColum = "th-table " + item.classNameColum + fijo + firstColumn + classHead;

    let nameHead = item.text || item.fecha;
    if ((isMinutaVertical || isMinutaHorizontal) && item.dia !== undefined) {
        nameHead = "Día " + item.dia;
    }
 
    
    return (
        <th
            ref={thRef}
            style={item.style}
            className={item.classNameColum}
            scope={scope}
        >
            {item.hideColumn ? (
                <>
                    <Button type="button" className="btn btn-link">
                        {nameHead}
                    </Button>
                    <button
                        type="button"
                        className="icon-btn"
                        onClick={async () => {
                            let fechas: any = [];
                            if (!item.show) {
                                if (!fechas.includes(item.id)) {
                                    fechas.push(item.id);
                                }
                                setLStorage("openFechas", JSON.stringify(fechas));
                            } else {
                                setLStorage(
                                    "openFechas",
                                    JSON.stringify(fechas.filter((item2: any) => item2 !== item.id))
                                );
                            }
                            return item.eventShow ? item.eventShow(item, index) : undefined;
                        }}
                    >
                        <i className="bi bi-chevron-right icon-show"></i>
                    </button>
                </>
            ) : (
                <Button type="button" className="btn btn-link">
                    {getTitleColumn(nameHead || '')}
                </Button>
            )}
        </th>
    );
};

ColumnGrid.defaultProps = {
    isMinutaVertical: false,
    isMinutaHorizontal: false,
};
export interface columnGrid {
    text?: string;
    fecha?: string;
    value?: string;
    className2?: string;
    dia?: string;
    type?: string;
    style?: React.CSSProperties;
    key: string;
    width?: string;
    classNameColum?: string;
    classNameRow?: string;
    hideColumn?: string[];
    dataFecha?: any;
    eventShow?(rows: {}, id: number): void | undefined;
    show?: boolean;
    id?: number;
    showModal?: boolean;
    showModalItem?: boolean;
    numRow?: number;
    head?: any;
    isMinutaVertical?: boolean;
}

interface columnGridProps {
    isHeader?: boolean;
    isCheckbox?: boolean;
    column?: columnGrid[];
    showModal?: false;
    isMinutaVertical?: boolean;
    showModalItem?: false;
    isMinutaHorizontal?: boolean;
}

interface ColumnHeaderProps {
    item: columnGrid;
    index: number;
    isMinutaVertical?: boolean;
    isMinutaHorizontal?: boolean;
}

export { ColumnGrid };
